import { Input as InputAntd } from 'antd';
import React from 'react';
import { EnumFormItemStatus } from 'src/types/common/validation';
import { controlSymbolFilter } from '../../../tools/helper';
import css from './Search.less';

import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { getI18nFromGeneral } from '@/src/tools/tools';
const { Search } = InputAntd;
interface IProps {
  className?;
  enterButton?;
  prefix?;
  onPressEnter?;
  onChange?;
  value?;
  onSearch;
  placeholder;
  allowClear;
  customFilterFun?;
  maxLength?;
  suffix?;
  size?;
  autoFocus?;
  help?;
  error?;
  customFilter?;
  formClassName?;
}

const SearchInput = (props: IProps) => {
  const {
    className,
    onChange,
    prefix,
    suffix,
    onPressEnter,

    placeholder,
    allowClear,
    maxLength,
    size,
    autoFocus,
    error,
    help,
    customFilter,
    formClassName,
    ...rest
  } = props;
  const textOnchange = (e) => {
    if (onChange) {
      let value = e.target.value;
      value = controlSymbolFilter(value);
      if (customFilter) {
        value = customFilter(value);
      }
      onChange(value, e);
    }
  };

  return (
    <FormItem
      className={formClassName || ''}
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}>
      <Search
        className={`${css.inpuStyle} ${
          size === 'large' ? css.largeStyle : ''
        } ${className || ''} `}
        onChange={textOnchange}
        maxLength={maxLength}
        prefix={prefix}
        suffix={suffix}
        autoFocus={autoFocus}
        onPressEnter={onPressEnter}
        placeholder={placeholder}
        allowClear={allowClear}
        size={size}
        {...rest}
      />
    </FormItem>
  );
};
export default SearchInput;
